<template>
  <el-form :model="loginModel" :rules="rules2" ref="loginModel" label-position="left" label-width="0px" class="demo-ruleForm login-container">
    <h3 class="title">系统登录</h3>
    <el-form-item prop="username">
      <el-input type="text" auto-complete="off" placeholder="用户名" v-model="loginModel.username"></el-input>
    </el-form-item>
    <el-form-item prop="password">
      <el-input type="password" auto-complete="off" placeholder="密码" v-model="loginModel.password" @keyup.enter.native="loginSubmit"></el-input>
    </el-form-item>
    <el-form-item prop="verification">
      <el-input type="text" auto-complete="off" placeholder="验证码" v-model="loginModel.verification" @keyup.enter.native="loginSubmit"></el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" style="width:100%;" @click.native.prevent="loginSubmit" :loading="logining">登录</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
  import NProgress from 'nprogress'
  import config from '../config'
  export default {
    data() {
      return {
        logining: false,
        loginModel: {
          username: '',
          password: '',
          verification: ''
        },
        rules2: {
          username: [
            { required: true, message: '请输入用户名', trigger: 'blur' }
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' }
          ]
        },
        checked: true
      };
    },
    methods: {
      loginSubmit(ev) {
        this.$refs.loginModel.validate((valid) => {
          if (valid) {
            this.logining = true;
            NProgress.start();
            const loginParams = {name: this.loginModel.username, pwd: this.loginModel.password, auth: this.loginModel.verification};
            this.$axios.post(config.api_url + '/login', loginParams).then((response) => {
              this.logining = false;
              NProgress.done();
              if(response.data.state) {
                let token = response.data.msg;
                this.$cookie.set('token_admin', token, { expires: '8755h' });
                this.$router.push({ path: '/' });
                this.$router.push("/");
              } else {
                this.$message({
                  message: '登录失败，'+response.data.msg,
                  type: 'warning'
                });
              }
            }).catch((error) => {
              this.logining = false;
              console.log(error);
              this.$message({
                message: '登录异常，请联系管理员',
                type: 'warning'
              });
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    }
  }
</script>

<style scoped>
  .login-container {
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0 0 rgba(0, 0, 0, 0.02);
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    background-color: #F9FAFC;
    margin: 180px auto;
    border: 2px solid #8492A6;
    width: 350px;
    padding: 35px 35px 15px 35px;
  .title {
    margin: 0 auto 40px auto;
    text-align: center;
    color: #505458;
  }
  .remember {
    margin: 0 0 35px 0;
  }
  }
</style>



// WEBPACK FOOTER //
// login.vue?765b4270